<template>
  <div>
    <base-dialog :show="successModal" small>
      <div class="success my-10">
        <img src="../assets/success.svg" alt="" />
        <h2 class="mt-10 text-white">เพิ่มสำเร็จ</h2>
      </div>
    </base-dialog>
    <base-dialog :show="adminDialog" small @close="toggleAdminDialog">
      <form @submit.prevent="submitForm">
        <h2 class="text-center mt-6 mb-8">เพิ่มแอดมิน</h2>
        <div class="grid grid-cols-12 gap-x-10 gap-y-3 px-10 items-center">
          <p class="col-span-4 text-right">ประเภทแอดมิน</p>
          <select
            class="col-start-5 col-span-8 w-full"
            v-model="role_id"
            required
          >
            <option
              v-for="role in adminRoleList"
              :key="role.role_id"
              :value="role.role_id"
            >
              {{ role.role_name }}
            </option>
          </select>
          <p class="col-span-4 text-right">ชื่อผู้ใช้งาน</p>
          <input
            type="text"
            class="col-span-8 add"
            required
            v-model="username"
          />
          <p class="col-span-4 text-right">รหัสผ่าน</p>
          <input
            type="password"
            class="col-span-8"
            required
            v-model="password"
          />
          <p class="col-span-4 text-right">ชื่อ</p>
          <input type="text" class="col-span-8 add" required v-model="name" />
        </div>
        <div class="grid grid-cols-10 gap-x-3 mt-8 mb-6">
          <vs-button
            class="col-span-3 col-start-3"
            color="#ffffff"
            text-color="#8d9498"
            @click="toggleAdminDialog"
          >
            ยกเลิก
          </vs-button>
          <vs-button class="col-span-3" button="submit" color="#15c1c3">
            บันทึก
          </vs-button>
        </div>
      </form>
    </base-dialog>
    <base-dialog :show="displayDelete" small>
      <div class="mx-5 my-5">
        <h4 class="text-white">ยืนยันการลบแอดมินนี้</h4>
        <div class="grid grid-cols-12 gap-4 mt-20">
          <vs-button
            class="col-end-9 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayDelete = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-4"
            color="#15c1c3"
            @click="confirmDeleteAdmin"
            >ยืนยัน</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <transition name="right">
      <div class="filter text-white" v-if="filterDisplay">
        <div class="filter-header grid grid-cols-3">
          <font-awesome-icon icon="times" class="close" @click="closeFilter" />
          <h2 class="text-white text-center">Filter By</h2>
        </div>
        <div class="filter-input">
          <label>สถานะ</label>
          <select
            class="w-full"
            v-model="filterRoleId"
            @change="loadFilteredTable"
          >
            <option :value="null">ALL</option>
            <option
              v-for="role in adminRoleList"
              :key="role.role_id"
              :value="role.role_id"
              >{{ role.role_name }}</option
            >
          </select>
          <vs-button
            class="mt-3"
            color="#ffffff"
            text-color="#8d9498"
            @click="resetFilter"
            >รีเซ็ต</vs-button
          >
        </div>
      </div>
    </transition>
    <div class="contentArea">
      <div class="pl-2">
        <div>
          <!-- <topTableButton /> -->
          <!-- <tabComponent /> -->
          <div class="w-full">
            <div class="flex justify-between ml-3 date-filter">
              <div>
                <vs-button
                  v-if="permission.admin_create"
                  color="#15c1c3"
                  style="width: 160px;"
                  @click="toggleAdminDialog"
                >
                  <font-awesome-icon icon="plus" class="mr-1" />
                  เพิ่มแอดมิน
                </vs-button>
              </div>
              <div class="flex">
                <vs-button
                  color="#f2a655"
                  class="mr-3 px-px"
                  style="width: 122px;"
                  type="border"
                  @click="filterDisplay = true"
                >
                  <font-awesome-icon
                    icon="filter"
                    class="mr-1"
                    :style="{ color: '#f2a655' }"
                  />
                  Filter by
                </vs-button>
                <div class="search flex items-center">
                  <font-awesome-icon
                    icon="search"
                    class="mr-1"
                    :style="{ color: '#03a9f3' }"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
            <AgGrid :searchQuery="searchTerm" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import { mapGetters } from "vuex";
import axios from "axios";
import baseUrl from "../util/backend.js";
export default {
  components: {
    AgGrid,
  },
  data() {
    return {
      successModal: false,
      adminDialog: false,
      displayDelete: false,
      filterDisplay: false,
      filterRoleId: null,
      deleteId: null,
      searchTerm: "",
      adminRoleList: [],
      role_id: null,
      username: "",
      password: "",
      name: "",
    };
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
    permission() {
      return this.$store.getters.getPermission;
    },
  },
  methods: {
    closeFilter() {
      this.filterDisplay = false;
    },
    resetFilter() {
      this.filterRoleId = null;
      this.$store.dispatch(
        "general/getTable",
        this.tabActive.path || this.nowSlug
      );
    },
    async loadFilteredTable() {
      if (this.filterRoleId) {
        this.$store.dispatch("general/getFilteredAdminTable", {
          path: this.tabActive.path || this.nowSlug,
          roleId: this.filterRoleId,
        });
      } else {
        this.$store.dispatch(
          "general/getTable",
          this.tabActive.path || this.nowSlug
        );
      }
    },
    async submitForm() {
      try {
        const res = await axios.post(
          `${baseUrl}/register`,
          {
            role_id: this.role_id,
            username: this.username,
            password: this.password,
            name: this.name,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res);
        if (res.data.status === "success") {
          this.toggleAdminDialog();
          this.clearData();
          this.successModal = true;
          setTimeout(() => {
            this.successModal = false;
          }, 1000);
          this.$store.dispatch(
            "general/getTable",
            this.tabActive.path || this.nowSlug
          );
        } else {
          const error = new Error(res.data.message);
          throw error;
        }
      } catch (err) {
        alert(err);
      }
    },
    clearData() {
      this.role_id = null;
      this.username = "";
      this.password = "";
      this.name = "";
    },
    async confirmDeleteAdmin() {
      const res = await axios.post(
        `${baseUrl}/profile/delete?user_id=${this.deleteId}`,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res);
      this.$store.dispatch("general/getTable", "sixth");
      this.displayDelete = false;
    },
    goToCreateAdmin() {
      this.$router.push("/createadmin");
    },
    toggleAdminDialog() {
      this.adminDialog = !this.adminDialog;
      this.clearData();
    },
    async loadData() {
      const role = await axios.get(`${baseUrl}/role/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.adminRoleList = role.data.data;
    },
  },
  mounted() {
    this.$root.$on("delete-modal", (id) => {
      this.displayDelete = true;
      this.deleteId = id;
    });
    // this.$store.dispatch("general/getTab", this.nowSlug);
    this.$store.dispatch(
      "general/getTable",
      this.tabActive.path || this.nowSlug
    );
  },
  watch: {
    tabActive(newValue) {
      this.$store.dispatch("general/getTable", newValue.path);
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
p,
h2 {
  color: #dddddd;
}

input[type="text"].add,
input[type="password"],
select {
  border-radius: 2px;
  background: #434f5b;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

.search input[type="text"] {
  font-size: 17px;
  border: none;
  border-radius: 2px;
  background-color: #3a3f51;
  width: 100px;
  color: #dddddd;
  padding: 10px 5px;
  transition: width 0.5s;
}

.search input[type="text"]:focus {
  width: 300px;
}

.search {
  padding-left: 10px;
  border-radius: 5px;
  border: solid 1.5px #03a9f3;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #03a9f3;
  opacity: 1; /* Firefox */
}

select,
input[type="text"],
input[type="password"] {
  height: 34px;
  min-width: 0;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.filter {
  position: absolute;
  right: 0;
  z-index: 1000000;
  background-color: #4e5363;
  width: 20%;
  height: 100vh;
}

.close {
  cursor: pointer;
  margin-top: 8px;
  margin-left: 8px;
  width: 15px;
  height: auto;
}

.filter-header {
  padding: 10px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.09);
}

.filter-input {
  padding: 20px;
}

.right-enter,
.right-leave-to {
  opacity: 0;
  right: -320px;
}

.right-enter-active {
  transition: all 0.3s ease-out;
}

.right-leave-active {
  transition: all 0.3s ease-in;
}

.right-enter-to,
.right-leave {
  opacity: 1;
  right: 0;
}
</style>
